import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PrezzoSpettacolo } from '../../../../shared/interface';
import { Table } from 'primeng/table';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { ApiService } from '../../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';

@Component({
  selector: 'app-prezzi-spettacolo-backoffice',
  templateUrl: './prezzi-spettacolo-backoffice.component.html',
  styleUrl: './prezzi-spettacolo-backoffice.component.css'
})
export class PrezziSpettacoloBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild(ConfirmPopup) delete!: ConfirmPopup;
  
  @Input() prezzi: PrezzoSpettacolo[] = [];
  @Output() data = new EventEmitter<PrezzoSpettacolo[]>();
  
  prezzo?: PrezzoSpettacolo;
  
  colonne: { header: string, value: string, type: string }[] = [
    { header: "Settore", value: "settore", type: "settore" },
    { header: "Prezzo Web Shop", value: "prezzo_webshop", type: "moneta" },
    { header: "Prezzo TicketOne", value: "prezzo_ticketone", type: "moneta" },
  ] 
  settori: { settore: string }[] = [
    { settore: 'Poltronissima' },
    { settore: 'Poltrona A' },
    { settore: 'Poltrona B' },
    { settore: 'Poltrona C' },
    { settore: 'Galleria A' },
    { settore: 'Galleria B' },
    { settore: 'Galleria C' }
  ];
  settori_filtrati: { settore: string }[] = [...this.settori];

  add: boolean = false;
  edit: boolean = false;

  formPrezzo!: FormGroup;

  ngOnInit(): void {

    this.formPrezzo = new FormGroup({
      settore: new FormControl(null, Validators.required),
      prezzo_webshop: new FormControl(null),
      prezzo_ticketone: new FormControl(null),
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onFilterSettori(event: AutoCompleteCompleteEvent) {      
    this.settori_filtrati = this.settori.filter(settore => settore.settore.toLowerCase().indexOf(event.query.toLowerCase()) == 0)     
  }

  onOpenAdd() {
    this.add = true;
    this.formPrezzo.reset();
    this.formPrezzo.markAsPristine();
    this.formPrezzo.markAsUntouched();
  }

  onAdd() {

    let prezzo: any = {
      settore: this.formPrezzo.get('settore')?.value ? (this.formPrezzo.get('settore')?.value.settore ? this.formPrezzo.get('settore')?.value.settore : this.formPrezzo.get('settore')?.value) : '-',
      prezzo_webshop: this.formPrezzo.get('prezzo_webshop')?.value || 0,
      prezzo_ticketone: this.formPrezzo.get('prezzo_ticketone')?.value || 0,
    }

    this.prezzi.push(prezzo)

    this.onCloseModal();

  }

  onOpenEdit(prezzo: any) {
    this.prezzo = prezzo;

    this.formPrezzo.setValue({
      settore: prezzo.settore,
      prezzo_webshop: prezzo.prezzo_webshop || 0,
      prezzo_ticketone: prezzo.prezzo_ticketone || 0,
    })

    this.edit = true;
  }

  onEdit() {

    this.prezzi.filter(prezzo => prezzo.id === this.prezzo?.id).map(prezzo => {
      prezzo.settore = this.formPrezzo.get('settore')?.value ? (this.formPrezzo.get('settore')?.value.settore ? this.formPrezzo.get('settore')?.value.settore : this.formPrezzo.get('settore')?.value) : '-';
      prezzo.prezzo_webshop = this.formPrezzo.get('prezzo_webshop')?.value || 0;
      prezzo.prezzo_ticketone = this.formPrezzo.get('prezzo_ticketone')?.value || 0;
    });

    this.onCloseModal();

  }

  onOpenDeletePrezzo(event: Event, prezzo: PrezzoSpettacolo, index: number) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare il prezzo dallo spettacolo?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deletePrezzoSpettacolo(prezzo.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.prezzi.splice(index, 1)
            this.apiService.message("success", "Eliminazione", "Il prezzo è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDeletePrezzo() {
    this.delete.accept();
  }

  onAnnullaDeletePrezzo() {
    this.delete.reject();
  }

  onCloseModal() {    
    this.add = false;
    this.edit = false;
  }

}
